import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { apiGetStatistiques } from "../../api/ApiTracking";
import { Container, Form, Tab, Tabs } from "react-bootstrap";
import ComponentLoader from "../../components/layout/ComponentLoader";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentBarChart from "../../components/admin/statistiques/ComponentBarChart";
import ComponentPieChart from "../../components/admin/statistiques/ComponentPieChart";
import ComponentVisiteur from "../../components/admin/statistiques/ComponentVisiteur";
import { apiGetUsers } from "../../api/ApiUser";

const PageAdminStatistiques = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [intervalle, setIntervalle] = useState(7);
  const [loader, setLoader] = useState(false);
  const [tabKey, setTabKey] = useState("frequentation");

  const [allUsers, setAllUsers] = useState();

  const [labelsFrequentation, setLabelsFrequentation] = useState([]);
  const [datasetsFrequentation, setDatasetsFrequentation] = useState([]);

  const [labelsPagesConsultees, setLabelsPagesConsultees] = useState([]);
  const [datasetsPagesConsultees, setDatasetsPagesConsultees] = useState([]);

  const [datasetsFrequentationHoraire, setDatasetsFrequentationHoraire] = useState([]);

  const [visiteurs, setVisiteurs] = useState([]);

  const recupStatistiques = async (dateDepart) => {
    setLoader(true);

    const res = await apiGetStatistiques(
      ReduxInstance._id,
      "filter[createdAt][$gte]=" + dateDepart
    );

    if (res.data) {
      calculFrequentation(res.data);
      calculPagesConsultees(res.data);
      calculFrequentationHoraire(res.data);
      recupUsers(dateDepart);
      calculVisiteurs(res.data);
    }

    setLoader(false);
  };

  const formateDate = (date) => {
    const elem = date.split("-");
    const annee = elem[0];
    const mois = elem[1];
    const jour = elem[2];
    const dateCalculee = jour + "/" + mois + "/" + annee;
    return dateCalculee;
  };

  const calculeDateAnterieure = (intervalle) => {
    var date = new Date();
    date.setDate(date.getDate() - intervalle);
    var dateCalculee =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10 ? "0" : "") +
      (date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" : "") +
      date.getDate();

    return dateCalculee;
  };

  /* FONCTION PERMETTANT LE CALCUL DE LA FREQUENTATION JOURNALIERE/HEBDO/MENSUELLE */
  const calculFrequentation = (datas) => {
    const labelsFrequentationTemp = [];
    let dateEnCours = "";
    let datasFrequentationGlobale = [];
    let datasFrequentationUnique = [];

    for (var i = 0; i <= intervalle; i++) {
      dateEnCours = calculeDateAnterieure(i);
      // on rajoute le label dans le tableau des labels
      labelsFrequentationTemp.unshift(formateDate(dateEnCours));

      // pour cette date là on va extraire tous ls trackings (createdAt = dateEnCours)
      const connexionsGlobalesDuJour = datas.filter(
        (item) => item.createdAt.indexOf(dateEnCours) !== -1 // eslint-disable-line no-loop-func
      );

      // pour cette date, on va compter le nombre de sessions ouvertes par X users (si les gens sont venus 20 fois on compte 20)
      // car à chaque visite le traceurNavigation change
      const connexionsGlobales = [
        ...new Set(connexionsGlobalesDuJour.map((data) => data.traceurNavigation)),
      ];
      datasFrequentationGlobale.unshift(connexionsGlobales.length);

      // pour cette date, on va compter le nombre de visites uniques par User (idColidée unique)
      // car à chaque visite le idColidee ne change pas
      const connexionsUniques = [
        ...new Set(connexionsGlobalesDuJour.map((data) => data.idColidee)),
      ];
      datasFrequentationUnique.unshift(connexionsUniques.length);
    }

    setDatasetsFrequentation([
      {
        label: t("admin.PageAdminStatistiques.nbrVisites"),
        data: datasFrequentationGlobale,
        backgroundColor: "rgba(66, 74,96, 1)",
      },
      {
        label: t("admin.PageAdminStatistiques.nbrVisiteurs"),
        data: datasFrequentationUnique,
        backgroundColor: "rgba(255, 102, 0, 1)",
      },
    ]);
    setLabelsFrequentation(labelsFrequentationTemp);
  };

  /* FONCTION PERMETTANT LE CALCUL DE LA FREQUENTATION  DES PAGES CONSULTEES */
  const calculPagesConsultees = (datas) => {
    let labelsPagesConsulteesTemp = [];
    let datasetsPagesConsulteesTemp = [];
    let connexionsGlobalesSurIntervalle = [];
    let dateEnCours = "";

    for (var i = 0; i <= intervalle; i++) {
      dateEnCours = calculeDateAnterieure(i);
      // pour cette date là on va extraire tous ls trackings (createdAt = dateEnCours)
      const connexionsGlobalesDuJour = datas.filter(
        (item) => item.createdAt.indexOf(dateEnCours) !== -1 // eslint-disable-line no-loop-func
      );
      connexionsGlobalesSurIntervalle = connexionsGlobalesDuJour.concat(
        connexionsGlobalesSurIntervalle
      );
    }

    // on va identifier les noms de pages uniques consultées
    labelsPagesConsulteesTemp = [
      ...new Set(connexionsGlobalesSurIntervalle.map((data) => data.title)),
    ];
    // pour chaque page consultée,on va compter le nombre de fois ou elle apparait dans les logs
    labelsPagesConsulteesTemp.forEach((titrePage) => {
      let nbrVues = connexionsGlobalesSurIntervalle.filter((item) => item.title === titrePage);
      datasetsPagesConsulteesTemp.push(nbrVues.length);
    });
    setLabelsPagesConsultees(labelsPagesConsulteesTemp);
    setDatasetsPagesConsultees(datasetsPagesConsulteesTemp);
  };

  /* FONCTION PERMETTANT LE CALCUL DE LA FREQUENTATION HORAIRE*/
  const calculFrequentationHoraire = (datas) => {
    let heure = "";
    let horaireTemp = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    datas.forEach((element) => {
      heure = new Date(element.createdAt).getHours();
      horaireTemp[heure]++;
    });
    setDatasetsFrequentationHoraire([
      {
        label: t("admin.PageAdminStatistiques.nbrVisites"),
        data: horaireTemp,
        backgroundColor: "rgba(66, 74,96, 1)",
      },
    ]);
  };

  /* FONCTION PERMETTANT DE SORTIR LA FICHE DES VISITEURS */
  const calculVisiteurs = (datas) => {
    let dateEnCours = "";
    let connexionsGlobalesSurIntervalle = [];

    for (var i = 0; i <= intervalle; i++) {
      dateEnCours = calculeDateAnterieure(i);
      // pour cette date là on va extraire tous ls trackings (createdAt = dateEnCours)
      const connexionsGlobalesDuJour = datas.filter(
        (item) => item.createdAt.indexOf(dateEnCours) !== -1 // eslint-disable-line no-loop-func
      );
      connexionsGlobalesSurIntervalle = connexionsGlobalesDuJour.concat(
        connexionsGlobalesSurIntervalle
      );
    }

    let connexionsGlobalesSurIntervalleCopy = [...connexionsGlobalesSurIntervalle];

    const visiteursTemp = [
      ...new Map(connexionsGlobalesSurIntervalle.map((item) => [item["idColidee"], item])).values(),
    ];
    visiteursTemp.sort((a, b) => (a.prenom > b.prenom ? 1 : b.prenom > a.prenom ? -1 : 0));

    visiteursTemp.forEach((visiteur, index) => {
      const newArray = connexionsGlobalesSurIntervalleCopy.filter(
        (connexion) => connexion.idColidee === visiteur.idColidee
      );

      let newLog = [];
      newArray.forEach((log) => {
        let logCopy = { ...log };
        newLog.push(logCopy);
      });

      visiteur.logs = newLog;
    });
    setVisiteurs(visiteursTemp);
  };

  const recupUsers = async (dateDepart) => {
    const res = await apiGetUsers("filter[derniereVisite][$gte]=" + dateDepart);
    if (res.data) {
      setAllUsers(res.data);
    }
  };

  const haveMobile = (visiteur) => {
    if (allUsers) {
      const userFind = allUsers.filter((user) => user.idColidee === visiteur.idColidee);
      if (userFind.length) {
        /* Si le gars a acdepté les notif, on a un device token donc on sait qu'il a l'appli mobile*/
        if (userFind[0].deviceToken.length) {
          return userFind[0].deviceToken.length;
        }
        /* Sinon on cherche danses logs si il a une "application" */
        const userFindApplication = visiteur.logs.filter((log) => log.device === "application");
        if (userFindApplication.length) {
          return userFindApplication.length;
        }
      }
      return 0;
    }
  };

  useEffect(() => {
    if (intervalle) {
      recupStatistiques(calculeDateAnterieure(intervalle));
    }
  }, [intervalle]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminStatistiques.titre")} />
        <Form.Select
          value={intervalle}
          onChange={(e) => setIntervalle(e.target.value)}
          className="mb-2"
        >
          <option value="0"> {t("admin.PageAdminStatistiques.intervalle0")}</option>
          <option value="7"> {t("admin.PageAdminStatistiques.intervalle7")}</option>
          <option value="14">{t("admin.PageAdminStatistiques.intervalle14")}</option>
          <option value="21">{t("admin.PageAdminStatistiques.intervalle21")}</option>
          <option value="30">{t("admin.PageAdminStatistiques.intervalle30")}</option>
        </Form.Select>

        {loader && (
          <div className="text-center">
            <ComponentLoader />
          </div>
        )}
        {!loader && (
          <>
            <Tabs
              defaultActiveKey={tabKey}
              className="mb-3"
              onSelect={(selectedKey) => {
                setTabKey(selectedKey);
              }}
            >
              <Tab eventKey="frequentation" title={t("admin.PageAdminStatistiques.frequentation")}>
                <ComponentBarChart
                  titleGraphe={t("admin.PageAdminStatistiques.frequentation")}
                  labels={labelsFrequentation}
                  datasets={datasetsFrequentation}
                />
              </Tab>
              <Tab eventKey="horaire" title={t("admin.PageAdminStatistiques.horaire")}>
                <ComponentBarChart
                  titleGraphe={t("admin.PageAdminStatistiques.horaire")}
                  labels={[
                    "0h",
                    "1h",
                    "2h",
                    "3h",
                    "4h",
                    "5h",
                    "6h",
                    "7h",
                    "8h",
                    "9h",
                    "10h",
                    "11h",
                    "12h",
                    "13h",
                    "14h",
                    "15h",
                    "16h",
                    "17h",
                    "18h",
                    "19h",
                    "20h",
                    "21h",
                    "22h",
                    "23h",
                  ]}
                  datasets={datasetsFrequentationHoraire}
                />
              </Tab>
              <Tab
                eventKey="pagesConsultees"
                title={t("admin.PageAdminStatistiques.pagesConsultees")}
              >
                <div style={{ maxWidth: "500px", margin: "auto" }}>
                  <ComponentPieChart
                    titleGraphe={t("admin.PageAdminStatistiques.pagesConsultees")}
                    labels={labelsPagesConsultees}
                    datasets={datasetsPagesConsultees}
                  />
                </div>
              </Tab>
              <Tab
                eventKey="visiteurs"
                title={visiteurs.length + " " + t("admin.PageAdminStatistiques.visiteurs")}
              >
                <div className="d-flex flex-wrap justify-content-center justify-content-lg-start">
                  {visiteurs.map((visiteur) => (
                    <ComponentVisiteur
                      haveMobile={haveMobile(visiteur)}
                      visiteur={visiteur}
                      key={visiteur.idColidee}
                      intervalle={intervalle}
                    />
                  ))}
                </div>
              </Tab>
            </Tabs>
          </>
        )}
      </Container>
    </>
  );
};

export default PageAdminStatistiques;
